import React from 'react'

export default function PaddingLeft({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'
    return (
        <svg
            className={className}
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path
                d='M13 3L10 3C8.89543 3 8 3.89543 8 5L8 15C8 16.1046 8.89543 17 10 17L13 17'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
            />
            <path d='M11 7L11 13' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
        </svg>
    )
}
